import { default as Popover, PopoverProps as Props } from "antd/lib/popover";
import React from "react";
import { createGlobalStyle } from "styled-components";

import * as Color from "~/Color";
import * as Shadow from "~/Shadow";

export const Component: Component<{
  readonly Title?: Component;
  readonly Content?: Component;
  readonly placement?: Props["placement"];
  readonly children?: Props["children"];
  readonly overlayStyle?: Props["overlayStyle"];
}> = ({ Title, Content, children, ...props }) => (
  <Popover title={Title} content={Content} {...props}>
    {children}
  </Popover>
);

export namespace AntOverride {
  export const Component = createGlobalStyle`
    .ant-popover-inner {
      ${Shadow.Box.styles(Shadow.offThePage())}
    }

    .ant-popover-title {
      color: ${Color.black()};
      font-weight: inherit;
    }

    .ant-popover-inner-content {
      color: ${Color.black()};
    }
  `;
}
